import React from 'react';
import { Counter, Reveal } from './motion';

/**
 * Capability facts about the platform itself — deliberately not customer/traction
 * numbers, so nothing here needs a footnote.
 */
const STATS = [
  { value: 5, suffix: '', label: 'Roles, from athlete to club admin' },
  { value: 9, suffix: '', label: 'Seats of meter attribution per eight' },
  { value: 7, suffix: '', label: 'Training modalities in the log' },
  { value: 2, suffix: '', label: 'Live feeds: weather + USGS gauge' },
];

export default function StatsBand() {
  return (
    <section className="relative border-y border-white/10 bg-slate-950">
      <div className="mx-auto max-w-6xl safe-area-x py-10 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 gap-8 sm:gap-6 lg:grid-cols-4">
          {STATS.map((s, i) => (
            <Reveal key={s.label} delay={i * 0.08} y={16}>
              <p className="bg-gradient-to-br from-white to-slate-400 bg-clip-text text-4xl font-bold tracking-tight text-transparent sm:text-5xl">
                <Counter to={s.value} />
                {s.suffix}
              </p>
              <p className="mt-2 text-sm leading-snug text-slate-400">{s.label}</p>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
